// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProspectCodeService = {};

ProspectCodeService.getProspectList = function (userInput) {
  return lossClient({
    url: "/inputprospect/search?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default ProspectCodeService;
